import React, { FC, useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import CustomTooltip from '@/pages/IndustrialGreenMicBigScreen/components/CustomTooltip';
import { formatElectricity, formatPower, keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import { Select } from '@maxtropy/components';
import {
  apiV2MicrogridOverviewGetBsaTodayInfoPost,
  V2MicrogridOverviewGetBsaTodayInfoPostResponse,
  V2MicrogridOverviewGetNewEnergyExistsPostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { useRequest } from 'ahooks';

interface IBsaDataBox {
  top: number;
  left: number;
  leftTitle: string;
  dataExit?: V2MicrogridOverviewGetNewEnergyExistsPostResponse;
  getBsaData?: (val: V2MicrogridOverviewGetBsaTodayInfoPostResponse) => void;
}

const BsaDataBox: FC<IBsaDataBox> = props => {
  const { top, left, leftTitle, dataExit, getBsaData } = props;
  const bsaList = dataExit?.bsaList ?? [];
  const { microgridId } = useContext(ShareDataContext);
  const [bsaId, setBsaId] = useState<number>();

  // 默认选择第一个bsa
  useEffect(() => {
    if (!bsaList || bsaList.length === 0) return;
    setBsaId(bsaList[0].bsaId);
  }, [bsaList]);

  // 储能数据
  const { data: bsaData } = useRequest(
    async () => {
      const res = await apiV2MicrogridOverviewGetBsaTodayInfoPost({
        id: Number(microgridId),
        bsaId,
      });
      return res;
    },
    {
      ready: !!microgridId && !!bsaId,
      refreshDeps: [microgridId, bsaId],
      pollingInterval: 1000 * 60,
    }
  );

  useEffect(() => {
    if (!bsaData) return;
    getBsaData?.(bsaData);
  }, [bsaData]);

  return (
    <div className={styles.yuan_box} style={{ top: `${top}%`, left: `${left}%` }}>
      <div className={styles.left_top_bg}>{leftTitle}</div>
      <div className={styles.select_box}>
        <Select
          style={{ width: '100%', height: 26 }}
          placeholder={'请选择'}
          onChange={(v: number) => {
            setBsaId(v);
          }}
          value={bsaId}
          options={bsaList.map(item => ({
            label: item.bsaName,
            value: item.bsaId,
          }))}
          showSearch
          optionFilterProp="label"
        />
      </div>
      <div className={styles.capacity_box}>
        <div className={styles.label}>装机容量</div>
        <CustomTooltip
          title={`${keepTwoOrLine(bsaData?.ratedPower)}MW/${keepTwoOrLine(bsaData?.installedCapacity)}MWh`}
        >
          <div className={styles.value}>
            {keepTwoOrLine(bsaData?.ratedPower)}MW/{keepTwoOrLine(bsaData?.installedCapacity)}MWh
          </div>
        </CustomTooltip>
      </div>

      <div className={styles[`line0`]}>
        <div className={styles.label}>{'今日充电量'}</div>
        <CustomTooltip title={`${formatElectricity(bsaData?.todayCharge)}`}>
          <div className={styles.value} style={{ color: '#16DD8E' }}>
            {formatElectricity(bsaData?.todayCharge)}
          </div>
        </CustomTooltip>
      </div>
      <div className={styles[`line1`]}>
        <div className={styles.label}>{'今日放电量'}</div>
        <CustomTooltip title={`${formatElectricity(bsaData?.todayDischarge)}`}>
          <div className={styles.value} style={{ color: '#00ADFF' }}>
            {formatElectricity(bsaData?.todayDischarge)}
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
};

export default BsaDataBox;
